<ami-dialog-message [setting]="message"></ami-dialog-message>
<pg-item-create *ngIf="open.create" (close)="onCloseCreate()"></pg-item-create>

<pg-item-update
  *ngIf="open.update"
  (close)="onCloseUpdate()"
  [row]="itemToUpdate"
></pg-item-update>

<ami-table
  [settings]="table.settings"
  [data]="table.data"
  (action)="onReciveAction($event)"
></ami-table>
